module.exports = __webpack_public_path__ + "static/img/backBg.0cae6b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backBg.png
// module id = ZgwV
// module chunks = 0